export const tools = [
  {
    path: '/tools',
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/Tools'),
    children: [
      {
        path: 'participations',
        component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/components/ToolsParticipations'),
      },
      {
        path: 'clearing',
        component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/components/ToolsClearing'),
      },
      {
        path: 'import',
        component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/components/ToolsImport'),
      },
      {
        path: 'users',
        component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/components/ToolsUsers'),
      },
      {
        path: 'delete',
        component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/components/ToolsDelete'),
      },
    ],
    redirect: '/tools/participations',
  },
]
